import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Home } from "./Home/Home";
import { ThemeProvider } from "@material-ui/core/styles";
import { useTheme } from "./theme";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import PactForm from "./Form/PactForm";
import PactUser from "./classes/PactUser";
import AppBarAndDrawer from "./AppBarAndDrawer/AppBarAndDrawer";
import "./Styles.css";

var currentContext = new PactUser();
// <Route path="/user-profile" children={<UserProfile fitnessObj = {currentUser} searchObj = {currentSearch}/>}/>
export default function App() {
  const [currentTheme, setCurrentTheme] = useTheme();
  return (
    <>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ThemeProvider theme={currentTheme}>
          <Router>
            <div>
              <AppBarAndDrawer
                currentTheme={currentTheme}
                setCurrentTheme={setCurrentTheme}
              />
              <Switch>
                <Route
                  path="/pact-tool"
                  children={<PactForm currentContext={currentContext} />}
                />
                <Route
                  path="/"
                  children={<Home currentContext={currentContext} />}
                />
              </Switch>
            </div>
          </Router>
        </ThemeProvider>
      </MuiPickersUtilsProvider>
    </>
  );
}
